import { createUseStyles } from 'react-jss';
var useStyles = createUseStyles({
  refreshText: {
    pointerEvents: 'none',
    fontWeight: 'normal'
  }
});
export default useStyles;
//# sourceMappingURL=useStyles.js.map